import { AUTH_LOGIN, AUTH_LOGOUT, SET_SSO_INFO } from "../actions/auth";
import { ERRORS_SHOW } from "../actions/errors";
import { MENU_LOAD_ITEMS } from "../actions/menu";
import Api from "../../service/api-web";
import Cookies from "js-cookie";
import { KeycloakUtils } from "../../config/keycloak";
import router from "../../router";
import { THEME_STORAGE_KEY } from "./menu";

const state = {
  token: `${Cookies.get("authorization") || ""}${Cookies.get(
    "authorization1"
  ) || ""}${Cookies.get("authorization2") || ""}${Cookies.get(
    "authorization3"
  ) || ""}`,
  funcao: Cookies.get("funcao") || "for",
  companyName: Cookies.get("companyName") || "",
  usesSSO: Cookies.get("usesSSO") === "true" || false,
  keycloakToken: Cookies.get("keycloak_token") || "",
  keycloakRefreshToken: Cookies.get("keycloak_refresh_token") || "",
  tokenRefreshing: false
};

const getters = {
  isAuthenticated: state => !!state.token,
  isAdmin: state => state.funcao === "adm",
  isUsesSSO: state => state.usesSSO,
  hasRefreshToken: state => !!state.keycloakRefreshToken,
  isTokenRefreshing: state => state.tokenRefreshing
};

const actions = {
  [AUTH_LOGIN]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.login(payload)
        .then(resp => {
          commit(AUTH_LOGIN, resp.data);
          if (!(resp?.data?.funcao === "adm")) {
            dispatch(MENU_LOAD_ITEMS);
          }
          if (resp.data.expiresIn) {
            KeycloakUtils.startTokenRefreshTimer(resp.data.expiresIn);
          }
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  refreshToken: ({ commit, state }) => {
    return new Promise(async (resolve, reject) => {
      if (state.tokenRefreshing) {
        const checkInterval = setInterval(() => {
          if (!state.tokenRefreshing) {
            clearInterval(checkInterval);
            resolve({ success: true });
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("Timeout no refresh token"));
        }, 30000);

        return;
      }

      commit("SET_TOKEN_REFRESHING", true);

      try {
        const result = await KeycloakUtils.refreshToken();

        commit("UPDATE_TOKENS", {
          authorization: result.authorization,
          authorization1: result.authorization1,
          authorization2: result.authorization2,
          authorization3: result.authorization3,
          keycloakToken: result.keycloakToken,
          refreshToken: result.refreshToken
        });

        resolve(result);
      } catch (error) {
        if (
          error.message.includes("Sessão expirada") ||
          error.message.includes("Login necessário")
        ) {
          commit(AUTH_LOGOUT);
          if (router.currentRoute.path !== "/login") {
            router.replace({ path: "/login" });
          }
        }

        reject(error);
      } finally {
        commit("SET_TOKEN_REFRESHING", false);
      }
    });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(async resolve => {
      try {
        if (KeycloakUtils.refreshTimer) {
          clearTimeout(KeycloakUtils.refreshTimer);
        }
        const logoutResponse = await Api.logout();
        resolve(logoutResponse.data);
      } catch (err) {
        resolve({ success: true });
      } finally {
        setTimeout(() => {
          let savedTheme = null;
          savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
          localStorage.clear();
          if (savedTheme === "0" || savedTheme === "1") {
            localStorage.setItem(THEME_STORAGE_KEY, savedTheme);
          }
          commit(AUTH_LOGOUT);
          router.replace({ path: "/login" });
        }, 100);
      }
    });
  }
};

const mutations = {
  [AUTH_LOGIN]: (state, payload) => {
    let {
      authorization = "",
      authorization1 = "",
      authorization2 = "",
      authorization3 = "",
      funcao = "for",
      keycloakToken = "",
      refreshToken = ""
    } = payload;
    state.funcao = funcao;
    state.token = `${authorization}${authorization1}${authorization2}${authorization3}`;
    state.keycloakToken = keycloakToken;
    state.keycloakRefreshToken = refreshToken;
    const cookieConfig = { expires: 365, secure: true };
    Cookies.set("authorization", authorization, cookieConfig);
    Cookies.set("authorization1", authorization1, cookieConfig);
    Cookies.set("authorization2", authorization2, cookieConfig);
    Cookies.set("authorization3", authorization3, cookieConfig);
    Cookies.set("keycloak_token", keycloakToken, cookieConfig);
    Cookies.set("funcao", funcao);
    if (refreshToken) {
      Cookies.set("keycloak_refresh_token", refreshToken, cookieConfig);
    }
  },
  [AUTH_LOGOUT]: state => {
    state.token = "";
    state.funcao = "for";
    state.keycloakToken = "";
    state.keycloakRefreshToken = "";
    state.tokenRefreshing = false;
    Cookies.set("authorization", "");
    Cookies.set("authorization1", "");
    Cookies.set("authorization2", "");
    Cookies.set("authorization3", "");
    Cookies.set("funcao", "for");
    Cookies.set("keycloak_token", "");
    Cookies.set("keycloak_refresh_token", "");
  },
  [SET_SSO_INFO]: (state, payload) => {
    state.companyName = payload.companyName;
    state.usesSSO = payload.usesSSO;
    Cookies.set("companyName", payload.companyName);
    Cookies.set("usesSSO", payload.usesSSO);
  },
  SET_TOKEN_REFRESHING: (state, refreshing) => {
    state.tokenRefreshing = refreshing;
  },
  UPDATE_TOKENS: (state, payload) => {
    let {
      authorization = "",
      authorization1 = "",
      authorization2 = "",
      authorization3 = "",
      keycloakToken = "",
      refreshToken = ""
    } = payload;
    state.token = `${authorization}${authorization1}${authorization2}${authorization3}`;
    state.keycloakToken = keycloakToken;
    if (refreshToken) {
      state.keycloakRefreshToken = refreshToken;
    }
    const cookieConfig = { expires: 365, secure: true };
    Cookies.set("authorization", authorization, cookieConfig);
    Cookies.set("authorization1", authorization1, cookieConfig);
    Cookies.set("authorization2", authorization2, cookieConfig);
    Cookies.set("authorization3", authorization3, cookieConfig);
    Cookies.set("keycloak_token", keycloakToken, cookieConfig);
    if (refreshToken) {
      Cookies.set("keycloak_refresh_token", refreshToken, cookieConfig);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
